export const Office = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='M19 11h-5.5M22 14H2M13 14v7h8v-7M3 21v-7'></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M5.637 9.686l-.625-5A1.5 1.5 0 016.5 3h6.375a1.5 1.5 0 011.488 1.314l.625 5A1.5 1.5 0 0113.5 11H7.125a1.5 1.5 0 01-1.488-1.314z'
          clipRule='evenodd'
        ></path>
      </svg>
    </span>
  );
};
